webpackJsonp([7],{

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(922)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(868),
  /* template */
  __webpack_require__(963),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-47a214bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 868:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      showBoolArray: [],
      iconIndex: '',
      searchKey: '',
      faqArray: [],
      filteredText: [],
      instructionArray: [],
      isLoading: false
    };
  },

  methods: {
    navigateToCentralAnalytics: function navigateToCentralAnalytics() {
      var _this = this;

      this.isLoading = true;
      setTimeout(function () {
        _this.$router.push('central_analytics');
      }, 500);
    }
  },
  mounted: function mounted() {
    this.faqArray = this.$store.state.CAR.faqs;
    this.instructionArray = this.$store.state.CAR.dashboardHelp;
    this.instructionArray.map(function (elem, index) {
      if (Array.isArray(elem.steps)) {
        elem.isArray = true;
      } else {
        elem.isArray = false;
      }
    });
    // console.log(this.instructionArray)
  },

  computed: {
    filterText: function filterText() {
      var _this2 = this;

      return this.instructionArray.filter(function (item) {
        return item.title.toLowerCase().includes(_this2.searchKey.toLowerCase());
      });
    }
  }
});

/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(802)(true);
// imports


// module
exports.push([module.i, "body[data-v-47a214bc]{background:#f5f5f5}", "", {"version":3,"sources":["/var/www/msdat-dashboard/src/components/dashboards/car/mainCar/car_help.vue"],"names":[],"mappings":"AACA,sBACE,kBAAmB,CACpB","file":"car_help.vue","sourcesContent":["\nbody[data-v-47a214bc]{\n  background:#F5F5F5;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 922:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(901);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("8e7cb1a4", content, true, {});

/***/ }),

/***/ 935:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    attrs: {
      "id": "loading-screen"
    }
  }, [_c('div', {
    staticClass: "fancy-loader"
  }, [_c('span', [_vm._v("LOADING")]), _vm._v(" "), _c('svg', {
    staticClass: "lds-comets",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "250px",
      "height": "250px",
      "viewBox": "0 0 100 100",
      "preserveAspectRatio": "xMidYMid"
    }
  }, [_c('g', {
    attrs: {
      "transform": "rotate(162.228 50 50)"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "repeatCount": "indefinite",
      "values": "360 50 50;240 50 50;120 50 50;0 50 50",
      "keyTimes": "0;0.333;0.667;1",
      "dur": "1s",
      "keySplines": "0.7 0 0.3 1;0.7 0 0.3 1;0.7 0 0.3 1",
      "calcMode": "spline"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#41918E",
      "d": "M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E0E0E0",
      "d": "M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#80CBC4",
      "d": "M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-md-12"
  }, [_c('div', {
    attrs: {
      "data-intro": "<b>Not Available on Help page</b><p>To play the tour guide, click on MSDAT platform and select the tour guide</p>"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.right",
      value: ('Back to platform'),
      expression: "'Back to platform'",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "back-to-car-icon",
    on: {
      "click": _vm.navigateToCentralAnalytics
    }
  }, [_c('v-icon', {
    staticClass: "back-to-car-icon-v",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("arrow_back")])], 1)])]), _vm._v(" "), _c('h1', {
    staticClass: "help_subtitle "
  }, [_vm._v("Help")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle my-3 "
  }, [_vm._v("Help to Use the Multi-Source Data Analytics & Triangulation (MSDAT) Platform")]), _vm._v(" "), _c('div', {
    staticClass: "text-center align-items-middle my-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    staticClass: "search-box",
    attrs: {
      "type": "text",
      "placeholder": "Search Help by typing a keyword..."
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.filterText), function(i, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "help-title",
      on: {
        "click": function($event) {
          i.show = !i.show
        }
      }
    }, [_c('span', {
      staticClass: "help-title-text"
    }, [_vm._v("\n        " + _vm._s(i.title) + "\n        "), _c('v-icon', {
      staticStyle: {
        "float": "right",
        "color": "white",
        "cursor": "pointer"
      },
      attrs: {
        "medium": ""
      }
    }, [_vm._v(_vm._s(i.show ? 'keyboard_arrow_up' : 'keyboard_arrow_down'))])], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i.show),
        expression: "i.show"
      }],
      staticClass: "help-text"
    }, [(i.isArray === true) ? _c('div', [_c('ul', _vm._l((i.steps), function(steps, count) {
      return _c('li', {
        key: count,
        staticClass: "helpList",
        domProps: {
          "innerHTML": _vm._s(steps)
        }
      })
    }))]) : _c('div', _vm._l((i.steps), function(key, counter) {
      return _c('div', {
        key: counter
      }, [_c('p', {
        staticStyle: {
          "margin-top": "20px",
          "font-weight": "bold"
        }
      }, [_vm._v(_vm._s(counter.replace('_', ' ')))]), _vm._v(" "), _c('ul', _vm._l((key), function(steps, count) {
        return _c('li', {
          key: count,
          staticClass: "helpList"
        }, [_vm._v(_vm._s(steps))])
      }))])
    }))])])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "-20px !important"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h1', {
    staticClass: "faq_subtitle",
    staticStyle: {
      "margin-top": "-40px !important"
    },
    attrs: {
      "id": "faq"
    }
  }, [_vm._v("Frequently Asked Questions (FAQs)")]), _vm._v(" "), _c('div', {
    staticClass: "faq_sub "
  }, [_vm._v("Answers to some Frequently Asked Questions (FAQs) about MSDAT Platform.")]), _vm._v(" "), _vm._l((_vm.faqArray), function(i, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "help-title",
      on: {
        "click": function($event) {
          i.show = !i.show
        }
      }
    }, [_c('span', {
      staticClass: "help-title-text"
    }, [_vm._v("\n        " + _vm._s(i.title) + "\n        "), _c('v-icon', {
      staticStyle: {
        "float": "right",
        "color": "white",
        "cursor": "pointer"
      },
      attrs: {
        "medium": ""
      }
    }, [_vm._v(_vm._s(i.show ? 'keyboard_arrow_up' : 'keyboard_arrow_down'))])], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i.show),
        expression: "i.show"
      }],
      staticClass: "help-text"
    }, [_c('ul', [_c('li', {
      staticClass: "helpList",
      domProps: {
        "innerHTML": _vm._s(i.ans)
      }
    })])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box row my-4 "
  }, [_c('div', {
    staticClass: "col-md-2 col-sm-12 pr-0 pl-4",
    staticStyle: {
      "padding-left": "50px !important"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "alt": "FAQ Icon",
      "src": __webpack_require__(935)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pl-0  col-md-8  col-sm-12"
  }, [_c('strong', [_vm._v("Got questions?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "15px",
      "font-weight": "bolder"
    }
  }, [_vm._v("See answers to some Frequently Asked Questions (FAQs) about the MSDAT Platform.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2  col-sm-12"
  }, [_c('button', {
    staticClass: "btn text-light",
    staticStyle: {
      "border": "none",
      "width": "110px !important"
    }
  }, [_c('a', {
    attrs: {
      "href": "#faq"
    }
  }, [_vm._v(" See FAQs")])])])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.18caaa0a8c8b2c0794dd.js